import React from 'react';

import { Typography } from '@/components/_atoms/Typography';
import { Color } from '@/types/colors.types';
import { MessagesKey } from '@/types/translations.types';

interface Props {
  color?: Color;
  textId: MessagesKey;
}

export const Badge = (props: Props) => {
  const { color = 'black', textId } = props;
  return (
    <div
      style={{
        backgroundColor: `var(--color-${color})`,
      }}
      className="h-6 rounded-xl px-2 flex items-center justify-center"
    >
      <Typography as="span" variant="body_xxs" color="white" id={textId} />
    </div>
  );
};
